import styled from "styled-components";

const PanelContainer = styled.div`
  .medical-panel {
    box-shadow: 0 2px 5px rgb(0 0 0 / 10%);
  }

  .medical-panel .ant-collapse-header {
    text-align: left;
    font-weight: 600;
    font-size: 15px;
    color: #045185;
  }

  span.ant-avatar.ant-avatar-circle.ant-avatar-image {
    border-radius: 0px;
    width: 60px;
    height: 60px;
  }

  .ant-list-item-meta-content {
    text-align: initial;
    margin-left: 10px;
  }

  li.ant-list-item {
    padding: 17px 0;
  }

  h4.ant-list-item-meta-title a {
    color: #045185;
  }

  button.ant-btn.ant-btn-primary.ant-btn-round {
    background-color: #045185;
    border: none;
    font-size: 10px;
  }

  .undefined-result {
    padding: 30px 0;
    font-size: 13px;
    font-weight: 700;
    color: #045185;
    text-transform: uppercase;
  }

  .report-content {
    font-size: 12px;
    text-align: end;
    color: #045185;
  }

  th.ant-table-cell.investigation-title {
    font-weight: 500;
    border-bottom: 1px solid;
  }

  td.ant-table-cell.investigation-title.ant-table-cell-fix-left.ant-table-cell-fix-left-last {
    font-weight: 700;
    font-size: 12px;
  }

  td.ant-table-cell.investigation-title {
    font-size: 13px;
    font-weight: 500;
  }

  span.uploaded-date {
    display: block;
  }

  .uploaded-doc span {
    font-weight: 600;
  }

  .dot {
    height: 13px;
    width: 13px;
    background-color: rgb(200, 200, 200);
    border-radius: 50%;
    display: inline-block;
  }

  .active-btn {
    background-color: #045185;
    color: #fff;
  }

  .test-button-container {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;
  }

  .ant-collapse-header {
    border-bottom: 1px solid #045185;
  }

  .button-container {
    margin: 4px;
  }

  .ant-collapse.ant-collapse-borderless.ant-collapse-icon-position-left.site-collapse-custom-collapse {
    box-shadow: 0 2px 5px rgb(0 0 0 / 10%);
  }

  .ant-table-content::-webkit-scrollbar {
    width: 80px;
  }

  /* Track */
  .ant-table-content::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
  }

  /* Handle */
  .ant-table-content::-webkit-scrollbar-thumb {
    background: rgb(200, 200, 200);
    border-radius: 10px;
  }
`;

export { PanelContainer };
